<div *ngIf="(raceSyncProgress$ | async) as syncProgress" class="progress-indicator"
  [class.sync-complete]="syncProgress?.percent == 100"
  [hidden]="!syncProgress.display"
>
  <div class="bar" [style.width.%]="syncProgress?.percent"></div>
  <div class="label" *ngIf="syncProgress?.lastLapTime">{{syncProgress?.percent}}%</div>
</div>
